module.exports = __webpack_public_path__ + "img/techcrunch.1f352422.png";